import axios from "axios";
import store from "../store/index"
import Message from "element-ui/packages/message/src/main";
import { local } from "@/utils/storage";
import router from "@/router";
axios.defaults.timeout = 1000000
axios.interceptors.request.use(config => {
    if (local.get("Token")) {
        config.headers["Authorization"] = 'Bearer ' + local.get("Token");
        config.headers["currentOrganizationId"] = local.get("currentOrganizationId")
        store.commit('showLoading')
    }
    // Authorization Bearer
    return config;
}, error => {
    store.commit('hideLoading')
    return Promise.reject(error);
});
axios.interceptors.response.use(response => {
    store.commit('hideLoading')
    return response;
}, error => {
    if (error.response) {
    switch (error.response.status) {
            case 302:
                store.commit('hideLoading')
                local.clear()
                router.push('/')
                break;
            case 401:
                store.commit('hideLoading')
                Message.error(error.response.data.Message);
                local.clear()
                router.push('/')
                break;
            case 500:
                store.commit('hideLoading')
                Message.error("服务器出现错误")
                break;
            case 404:
                store.commit('hideLoading')
                Message.error("404接口调用错误")
                break;
        }
        return Promise.reject(error.response.data);
    }
    if (error && error.stack.indexOf('timeout') > -1) {
        store.commit('hideLoading')
        Message.error('现在网络不稳定,请稍后在试!')
    }
});

export default axios;
